module.exports = __webpack_public_path__ + "c86a680cfeb4d112d1a85bf271642f3a.svg";